import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import FieldHorizontal from '@/components/FieldHorizontal/FieldHorizontal'

export default {
  name: 'CalibrationRow',
  props: ['calibration'],
  data() {
    return {
      open: false,
      editable: false,
      changes: {}
    }
  },
  computed: {
    editableCalibration: {
      get() {
        return this.calibration
      }
    }
  },
  components: {
    FontAwesomeIcon,
    FieldHorizontal
  },
  methods: {
    openRow(bool) {
      this.$data.open = bool
    },
    editCalibration() {
      this.$data.editable = true
    },
    updateCalibration(key, value) {
      this.$data.changes[key] = value
    },

    saveCalibration() {
      // Prep payload + convert timestamps to Unix
      const payload = Object.assign({}, this.calibration, this.$data.changes)
      payload.datetimeStartCalibration = payload.datetimeStartCalibration ? (new Date(payload.datetimeStartCalibration).getTime() / 1000).toFixed(0) : null
      payload.datetimeEndCalibration = payload.datetimeEndCalibration ? (new Date(payload.datetimeEndCalibration).getTime() / 1000).toFixed(0) : null
      this.$store
        .dispatch('saveCalibration', payload)
        .then(() => {
          this.$data.editable = false
          this.$data.changes = {}
          // Fetch updated calibrations
          this.$store.dispatch('getCalibrations')
        })
    },
    getData(attr) {
      return this.$data[attr]
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/CalibrationRow/script.js